export function isEmbedPath(pathname: string | null | undefined): boolean {
  return /^\/[^/]+\/embed(?:\/|$)/.test(pathname ?? "");
}

export function getEmbedAwareTenantPath(
  tenant: string,
  route: string,
  embed = false,
): string {
  return `/${tenant}/${embed ? "embed/" : ""}${route.replace(/^\/+/, "")}`;
}

export function getPatientPortalPath(
  tenant: string,
  suffix = "",
  embed = false,
): string {
  const normalizedSuffix = suffix ? `/${suffix.replace(/^\/+/, "")}` : "";
  return `${getEmbedAwareTenantPath(tenant, "patient-portal", embed)}${normalizedSuffix}`;
}
